import { useGamesStore } from '../../store';

export const useGetLiveRtpCategory = () => {
  return useGamesStore((store) => store.dynamicCategories.liveRtpGames);
};
